require('./retailLoanWizard.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require("react-router-dom");
const immutable = require('immutable');


// @common
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');


// @components
const RetailLoanSidebar = require('../../contractRetailLoan/retailLoanSidebar/retailLoanSidebar');
const RetailLoanStepOne = require('../../contractRetailLoan/retailLoanStepOne/retailLoanStepOne');
const RetailLoanStepTwo = require('../../contractRetailLoan/retailLoanStepTwo/retailLoanStepTwo');
const RetailLoanStepThree = require('../../contractRetailLoan/retailLoanStepThree/retailLoanStepThree');
const RetailLoanStepFour = require('../../contractRetailLoan/retailLoanStepFour/retailLoanStepFour');
const PayrollLoanRequestError = require('../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestError/payrollLoanRequestError');
const ContractLoanSuccess = require('../../contractLoanSuccess/contractLoanSuccess');
const ContractLoanTooltip = require('../../contractLoanTooltip/contractLoanTooltip');
const RetailLoanErrorAsnef = require('../../contractAsnefError/contractAsnefError');

// @core
const { formatText } = require('core/i18n').i18n;

//@constants
const { WIZARD_THIRD_STEP } = require('constants/index');
const {
    retailLoanDoTaggin: { TAGGING_CANCEL, NAME_PAGE_WIZARD_VIEW },
} = require('../../../../loansConstants/index');
const {
    ACTION_EVENT_VIEW,
    CHEVRON_CLOSE,
    DEFERRAL_PAYMENT_PREVIOUS,
    OPEN_MARKET_PRE_LEAVE_MODAL_EVENT_TAG
} = require('constants/tagging');
const { NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');
const {
    recordLinkV2,
    PROC_START,
    PROC_STEP,
} = require('utilities/tagging');

//@helpers
const {
    isRetailAddressDelivery,
    buildEventsWizardRetailLoan,
    buildLoadStepRetailLoanInfo,
} = require('../../../../loansUtilities/loansHelper');

class RetailLoanWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleModalCancelClick = this.handleModalCancelClick.bind(this);
        this.handleModalExitClick = this.handleModalExitClick.bind(this);
        this.handleModalCloseClick = this.handleModalCloseClick.bind(this);
        this.handlePreviousClickTaggings = this.handlePreviousClickTaggings.bind(this);
    }

    componentDidMount() {
        scrollToTop();
    }

    buildSidebar() {
        const { immAccounts, immRetailLoan } = this.props;
        const selectedAccount = immRetailLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const displayAssociatedAccount = immRetailLoan.get('visibleStep') === WIZARD_THIRD_STEP;

        return (
            <div className="col-xs-4">
                <RetailLoanSidebar
                    immAccount={immAccount}
                    immRetailLoan={immRetailLoan}
                    displayAssociatedAccount={displayAssociatedAccount}
                />
            </div>
        );
    }

    buildTaeTooltip(selectedAmount) {
        const { immRetailLoan } = this.props;

        return (
            <ContractLoanTooltip
                isRetailLoan
                decimalsLength={2}
                immContractLoan={immRetailLoan}
                customAmount={selectedAmount}
            />
        );
    }

    buildContent() {
        const sidebar = this.buildSidebar();
        const mainContent = this.buildWizard();
        const disclaimer = this.builDisclaimer();

        return (
            <React.Fragment>
                <div className="col-xs-8">
                    {mainContent}
                    {disclaimer}
                </div>
                {sidebar}
            </React.Fragment>
        );
    }

    buildStepOne(immSelectedItem) {
        const {
            downloadPreContractDocument,
            immRetailLoan,
            setTerm,
        } = this.props;

        const selectedAmount = immSelectedItem.get('field_total_product_price');
        const taeTooltip = this.buildTaeTooltip(selectedAmount);

        return (
            <RetailLoanStepOne
                immRetailLoan={immRetailLoan}
                setTerm={setTerm}
                taeTooltip={taeTooltip}
                customAmount={selectedAmount}
                downloadPreContractDocument={downloadPreContractDocument}
            />
        );
    }

    buildStepTwo(immSelectedItem) {
        const {
            changeBillingAddress,
            changeDeliveryAddressValue,
            formHandlers,
            getAsnefValidation,
            getInfoDestinationAccount,
            immFlagBasedFeatures,
            immRetailLoan,
            immProfile,
            setEmail,
            updatePersonalData
        } = this.props;

        return (
            <RetailLoanStepTwo
                beforeStep={immRetailLoan.get('beforeStep')}
                changeBillingAddress={changeBillingAddress}
                changeDeliveryAddressValue={changeDeliveryAddressValue}
                errorAsnef={immRetailLoan.get('errorAsnef')}
                formHandlers={formHandlers}
                getAsnefValidation={getAsnefValidation}
                getInfoDestinationAccount={getInfoDestinationAccount}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immRetailLoan={immRetailLoan}
                immProfileFields={immProfile}
                immSelectedItem={immSelectedItem}
                setEmail={setEmail}
                updatePersonalData={updatePersonalData}
            />
        );
    }

    buildStepThree() {
        const {
            downloanRetailLoanContractDocument,
            downloadINEDocument,
            getHiringDocuments,
            getProposition,
            immAccounts,
            immRetailLoan,
            immProfile,
            onDownloadDocument,
            onPrintDocument,
            processRequestConfiguration,
            resetAgreeThirdStep,
            setAgree,
            setSelectedAccount,
            immFlagBasedFeatures,
            checkReadDocument,
            checkCheckedDocument
        } = this.props;

        const email = immRetailLoan.get('newEmail') || PersonalDataHelper.getEmail(immProfile);

        return (
            <RetailLoanStepThree
                downloanRetailLoanContractDocument={downloanRetailLoanContractDocument}
                downloadINEDocument={downloadINEDocument}
                email={email}
                getHiringDocuments={getHiringDocuments}
                getProposition={getProposition}
                setAgree={setAgree}
                immRetailLoan={immRetailLoan}
                immAccounts={immAccounts}
                immProfile={immProfile}
                onDownloadDocument={onDownloadDocument}
                onPrintDocument={onPrintDocument}
                processRequestConfiguration={processRequestConfiguration}
                resetAgreeThirdStep={resetAgreeThirdStep}
                setSelectedAccount={setSelectedAccount}
                immFlagBasedFeatures={immFlagBasedFeatures}
                checkReadDocument={checkReadDocument}
                checkCheckedDocument={checkCheckedDocument}

            />
        );
    }

    buildStepFour() {
        const {
            downloanRetailLoanContractDocument,
            downloadINEDocument,
            getHiringDocuments,
            getProposition,
            immAccounts,
            immRetailLoan,
            immProfile,
            onDownloadDocument,
            onPrintDocument,
            processRequestConfiguration,
            resetAgreeThirdStep,
            setAgree,
            setSelectedAccount,
            immFlagBasedFeatures,
            checkReadDocument
        } = this.props;
        const email = immRetailLoan.get('newEmail') || PersonalDataHelper.getEmail(immProfile);

        return (
            <RetailLoanStepFour
                downloanRetailLoanContractDocument={downloanRetailLoanContractDocument}
                downloadINEDocument={downloadINEDocument}
                email={email}
                getHiringDocuments={getHiringDocuments}
                getProposition={getProposition}
                setAgree={setAgree}
                immRetailLoan={immRetailLoan}
                immAccounts={immAccounts}
                immProfile={immProfile}
                onDownloadDocument={onDownloadDocument}
                onPrintDocument={onPrintDocument}
                processRequestConfiguration={processRequestConfiguration}
                resetAgreeThirdStep={resetAgreeThirdStep}
                setSelectedAccount={setSelectedAccount}
                immFlagBasedFeatures={immFlagBasedFeatures}
                checkReadDocument={checkReadDocument}
            />
        );
    }
    buildSuccess() {
        const { immRetailLoan, immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);

        return (
            <div className="retail-loan-wizard__success row">
                <ContractLoanSuccess
                    immData={immRetailLoan}
                    viewToRender={"contract-payroll-loan"}
                    email={email}
                />
            </div>
        );
    }

    buildPreLeaveModalConfig() {
        return {
            message: formatText('retailLoanCommon-modalLeaveText'),
            title: formatText('retailLoanCommon-modalLeaveTitle'),
            leftButtonConfig: {
                text: formatText('wizard-redirectConfirmationAcceptButton'),
                redirect: true,
                callback: this.handleModalExitClick
            },
            rightButtonConfig: {
                text: formatText('wizard-redirectConfirmationCancelButton'),
                callback: this.handleModalCancelClick
            }
        }
    }

    handleCancel() {
        const { immRetailLoan } = this.props;
        const customData = buildEventsWizardRetailLoan(immRetailLoan, TAGGING_CANCEL);
        recordLinkV2(customData);
        this.handlePreCancelModalTaggings(ACTION_EVENT_VIEW);
        this.props.history.push('/myprofile/loans-mortgages');
    }

    builDisclaimer() {
        const content = formatText('retailLoanCommon-disclaimer');

        return (
            <div className="payroll-loan-request__disclaimer">
                {content}
            </div>
        )
    }

    handleModalCancelClick(callback) {
        this.handlePreCancelModalTaggings(formatText('wizard-redirectConfirmationCancelButton').toLowerCase());
        callback();
    }

    handleModalExitClick(callback) {
        this.handlePreCancelModalTaggings(formatText('wizard-redirectConfirmationAcceptButton').toLowerCase());
        callback();
    }

    handleModalCloseClick() {
        this.handlePreCancelModalTaggings(CHEVRON_CLOSE);
    }

    handlePreCancelModalTaggings(actionEvent) {
        const { immRetailLoan } = this.props;
        const visibleStep = immRetailLoan.get('visibleStep');
        const customData = {
            categoriaEvento: NAME_PAGE_WIZARD_VIEW,
            accionEvento: OPEN_MARKET_PRE_LEAVE_MODAL_EVENT_TAG,
            etiquetaEvento: actionEvent,
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };

        recordLinkV2(customData);
    }

    handlePreviousClickTaggings() {
        const { immRetailLoan } = this.props;
        const visibleStep = immRetailLoan.get('visibleStep');
        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const customData = {
            categoriaEvento: NAME_PAGE_WIZARD_VIEW,
            accionEvento: DEFERRAL_PAYMENT_PREVIOUS,
            etiquetaEvento: immSelectedItem.get('title'),
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };

        recordLinkV2(customData);
    }

    buildWizard() {
        const { immRetailLoan, validateStep, setVisibleStep, immProfile, immFlagBasedFeatures } = this.props;
        const newRetailLoadFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES)
        const immSteps = newRetailLoadFF ? immRetailLoan.get('newSteps') : immRetailLoan.get('steps');
        const isFetching = immRetailLoan.get('isFetchingFormalize') || immRetailLoan.get('isFetchingDocuments');
        const visibleStep = immRetailLoan.get('visibleStep');
        const stepsAmount = immSteps.size;

        const isNombreCompleto = !!immProfile.get('nombreCompleto');
        const isFetchingStepOne = !isNombreCompleto || immRetailLoan.get('isFetchingAsnef');
        const isFetchingAccount = immRetailLoan.get('isFetchingAccount');

        const cancelButtonText = formatText('common-cancel');

        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const deliveryType = immSelectedItem.get('field_pickup_option');
        const isStepTwoNextDisabled = !immRetailLoan.get('selectedPickup') && !isRetailAddressDelivery(deliveryType);

        const stepOneComponent = this.buildStepOne(immSelectedItem);
        const stepTwoComponent = this.buildStepTwo(immSelectedItem);
        const stepThreeComponent = this.buildStepThree();
        const stepFourComponent = this.buildStepFour();
        const agreeIneCheckbox = immRetailLoan.get('agreeIneCheckbox')
        const checkboxFlag = immRetailLoan.get('checkboxDisabled');

        const actions = {
            finish: this.handleFinish,
            cancel: this.handleCancel,
            validateStep,
            setVisibleStep,
            setWillCancel: () => { return false; },
            setWillGoBack: () => { return false; },
            resetStep: () => { return false; },
            previousClick: this.handlePreviousClickTaggings,
        };

        const preleaveModalConfig = this.buildPreLeaveModalConfig();
        const tealiumDataEvent = buildLoadStepRetailLoanInfo(
            immRetailLoan,
            visibleStep
        );
        const tealiumName = ["summary", "address", "INE", "confirmation"][
            visibleStep - 1
        ];

        const tealiumData = {
            ...tealiumDataEvent,
            event_name: `step_${tealiumName}`,
            pageName: `/openMarketsInformation/step${visibleStep}/${tealiumName}`,
            sectionFamily: "banking",
            sectionCategory: "products",
            sectionName: "loans",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType: "openMarketsInformation",
            processStep: `step${visibleStep}`,
            processDetail: `${tealiumName}`,
            productName: "openMarkets",
        };
        return (
            <>
                {newRetailLoadFF ?
                    <Wizard
                        immSteps={immSteps}
                        stepsAmount={stepsAmount}
                        visibleStep={visibleStep}
                        actions={actions}
                        preleaveModalMessage={preleaveModalConfig.message}
                        preleaveModalTitle={preleaveModalConfig.title}
                        preleaveModalLeftButtonConfig={preleaveModalConfig.leftButtonConfig}
                        preleaveModalRightButtonConfig={preleaveModalConfig.rightButtonConfig}
                        tealium={tealiumData}
                        onCloseButtonClick={this.handleModalCloseClick}
                        showPreLeaveModal
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            nextButton
                            position="first"
                            cancelButtonText={cancelButtonText}
                            cancelButton
                            isLoading={isFetchingStepOne}
                        >
                            {stepOneComponent}
                        </WizardStep>
                        <WizardStep
                            nextButton
                            position="middle"
                            cancelButtonText={cancelButtonText}
                            cancelButton
                            isLoading={isFetchingAccount}
                            nextButtonDisabled={isStepTwoNextDisabled}
                        >
                            {stepTwoComponent}
                        </WizardStep>
                        <WizardStep
                            position="middle"
                            cancelButtonText={cancelButtonText}
                            isLoading={isFetching && !checkboxFlag}
                            nextButtonDisabled={!agreeIneCheckbox}
                            nextButton
                            cancelButton
                        >
                            {stepThreeComponent}
                        </WizardStep>
                        <WizardStep
                            position="last"
                            finalButtonDisabled={!immRetailLoan.get('agreeThirdStep')}
                            immFinalButton="retailLoanCommon-ctaButton"
                            cancelButtonText={cancelButtonText}
                            isLoading={isFetching}
                            addLoadingBehaviour
                            cancelButton
                        >
                            {stepFourComponent}

                        </WizardStep>
                    </Wizard >
                    :

                    <Wizard
                        immSteps={immSteps}
                        stepsAmount={stepsAmount}
                        visibleStep={visibleStep}
                        actions={actions}
                        preleaveModalMessage={preleaveModalConfig.message}
                        preleaveModalTitle={preleaveModalConfig.title}
                        preleaveModalLeftButtonConfig={preleaveModalConfig.leftButtonConfig}
                        preleaveModalRightButtonConfig={preleaveModalConfig.rightButtonConfig}
                        tealium={tealiumData}
                        onCloseButtonClick={this.handleModalCloseClick}
                        showPreLeaveModal
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            nextButton
                            position="first"
                            cancelButtonText={cancelButtonText}
                            cancelButton
                            isLoading={isFetchingStepOne}
                        >
                            {stepOneComponent}
                        </WizardStep>
                        <WizardStep
                            nextButton
                            position="middle"
                            cancelButtonText={cancelButtonText}
                            cancelButton
                            isLoading={isFetchingAccount}
                            nextButtonDisabled={isStepTwoNextDisabled}
                        >
                            {stepTwoComponent}
                        </WizardStep>
                        <WizardStep
                            position="last"
                            finalButtonDisabled={!immRetailLoan.get('agreeThirdStep')}
                            immFinalButton="retailLoanCommon-ctaButton"
                            cancelButtonText={cancelButtonText}
                            isLoading={isFetching}
                            addLoadingBehaviour
                            cancelButton
                        >
                            {stepFourComponent}

                        </WizardStep>
                    </Wizard >
                }

            </>

        );
    }

    handleFinish() {
        const { immRetailLoan, validateStep, formalize } = this.props;
        const newRetailLoadFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES)
        const visibleStep = immRetailLoan.get('visibleStep');
        const agreeCheckbox = immRetailLoan.get('agree');

        if (!agreeCheckbox) {
            validateStep(visibleStep,newRetailLoadFF);
        } else {
            formalize();
        }
    }

    render() {
        let content;
        const { immRetailLoan } = this.props;
        const success = immRetailLoan.get('success');
        const error = immRetailLoan.get('error');
        const errorAsnef = immRetailLoan.get('errorAsnef');

        if (success) {
            content = this.buildSuccess();
        } else if (error) {
            content = <PayrollLoanRequestError />;
        } else if (errorAsnef) {
            const selectedItemId = immRetailLoan.get('purpose');
            const immProducts = immRetailLoan.get('products');
            const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
            content = (
                <RetailLoanErrorAsnef
                    errorValue={immSelectedItem.get('field_total_product_price')}
                />
            );
        } else {
            content = this.buildContent();
        }

        return (
            <div className="retail-loan-wizard row">
                {content}
            </div>
        );
    }
}

RetailLoanWizard.propTypes = {
    changeBillingAddress: PropTypes.func.isRequired,
    changeDeliveryAddressValue: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanRetailLoanContractDocument: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    formHandlers: PropTypes.object.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInfoDestinationAccount: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    processRequestConfiguration: PropTypes.func.isRequired,
    resetAgreeThirdStep: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setRetailLoanAccountsInactive: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setTerm: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    updatePersonalData: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(RetailLoanWizard);